import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { officePhoneNumber } from '../../constants-monisfer-infos';

@Component({
  selector: 'app-contact-us',
  imports: [MatProgressSpinnerModule],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
})
export class ContactUsComponent {
  phoneNumber = officePhoneNumber;
}
